import SlimSelect from 'slim-select';
jQuery(document).on('ready', function () {
    const objectSelect = new SlimSelect({
        select: '#rental-form-object',
        settings: {
            showSearch: false,
        },
        data: RENTAL_FORM_DATA['options']['rental-form-object'],
    });
    const locationSelect = new SlimSelect({
        select: '#rental-form-location',
        settings: {
            showSearch: false
        },
        data: RENTAL_FORM_DATA['options']['rental-form-location'],
    });
    const wishesSelect = new SlimSelect({
        select: '#rental-form-wishes',
        settings: {
            showSearch: false
        },
        data: RENTAL_FORM_DATA['options']['rental-form-wishes'],
    });
    const DateTime = easepick.DateTime;
    const today = new DateTime();
    let datePickerArgs = {
        element: '#rental-form-date',
        css: [
            'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
            'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.1/dist/index.css',
            'https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.1/dist/index.css',
            'https://ekerirent.com/wp-content/themes/ekerirent/easepick.css?ver=1.0.0',
        ],
        zIndex: 11,
        grid: 2,
        calendars: 2,
        lang: RENTAL_FORM_DATA['locale'],
        plugins: [
            "RangePlugin",
            "LockPlugin"
        ],
        RangePlugin: {
            strict: false,
            locale: {
                one: RENTAL_FORM_DATA['strings']['day'],
                other: RENTAL_FORM_DATA['strings']['days']
            }
        },
        LockPlugin: {
            minDate: new Date(),
        },
        header: `<div>
                    <input type="radio" checked name="rental_duration_type" value="ongoing" id="rental_duration_ongoing">
                    <label for="rental_duration_ongoing">${RENTAL_FORM_DATA['strings']['rental_duration_ongoing']}</label>
                    <input type="radio" name="rental_duration_type" value="exact" id="rental_duration_exact">
                    <label for="rental_duration_exact">${RENTAL_FORM_DATA['strings']['rental_duration_exact']}</label>
                </div>`,
        setup(picker) {
            var rentalDurationType = 'ongoing';
            picker.on('render', (e) => {
                e.target.querySelector(`input[value="${rentalDurationType}"]`).checked = true;
                e.target.querySelectorAll('input[name="rental_duration_type"]').forEach((radio) => {
                    radio.addEventListener('change', (event) => {
                        rentalDurationType = event.target.value;
                        picker.clear();
                    });
                });
            });
            picker.on('select', (e) => {
                if (rentalDurationType == 'ongoing') {
                    picker.hide();
                }
            });
        },
    };
    if (RENTAL_FORM_DATA['prefilled']['rental-form-date']) {
        datePickerArgs.date = RENTAL_FORM_DATA['prefilled']['rental-form-date'];
    }
    const datePicker = new easepick.create(datePickerArgs);
    jQuery('.wm-request .wpcf7-form').addClass('-loading');
    setTimeout(function () {
        if (RENTAL_FORM_DATA['prefilled']['rental-form-object']) {
            objectSelect.setSelected(RENTAL_FORM_DATA['prefilled']['rental-form-object']);
        }
        if (RENTAL_FORM_DATA['prefilled']['rental-form-location']) {
            locationSelect.setSelected(RENTAL_FORM_DATA['prefilled']['rental-form-location']);
        }
        if (RENTAL_FORM_DATA['prefilled']['rental-form-date']) {
            document.getElementById('rental-form-date').setAttribute('value', RENTAL_FORM_DATA['prefilled']['rental-form-date']);
        }
        if (RENTAL_FORM_DATA['prefilled']['rental-form-wishes']) {
            wishesSelect.setSelected(RENTAL_FORM_DATA['prefilled']['rental-form-wishes']);
        }
        jQuery('option[value="null"]').removeAttr('value');
        jQuery('.wm-request .wpcf7-form').removeClass('-loading');
    }, 3000);
});
